import hasUnlockedSecondTierTrackerCartSelect from 'modules/cart/redux/selectors/has-unlocked-second-tier-tracker'
import getSubtotalCartDiscountTrackerDeliverySelectUtil from 'pages/Cart/components/CartDiscountTracker/selectors/get-subtotal/utils'
import isGiftUrlLocationUtil from 'utils/location/is-gift-url'
import hasGiftCardCartSelect from 'modules/cart/redux/selectors/has-gift-card'
import getAmountGiftSelect from 'modules/gift/redux/selectors/get-amount'

const getSubtotalCartDiscountTrackerDeliverySelect = state => {
  return getSubtotalCartDiscountTrackerDeliverySelectUtil({
    hasUnlockedSecondTierCartTracker: hasUnlockedSecondTierTrackerCartSelect(state),
    state,
    isGiftUrl: isGiftUrlLocationUtil(),
    hasGiftCard: hasGiftCardCartSelect(state),
    giftAmount: getAmountGiftSelect(state)
  })
}

export default getSubtotalCartDiscountTrackerDeliverySelect
